export const firstBreakpoint = 1152;
export const secondBreakpoint = 620;